import { connect } from 'react-redux'
import { DynamicTrustSelect } from './component'

export default connect()(DynamicTrustSelect)
